import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts';
import { canRunStaffActions } from '../utils';

interface StaffOnlyRouteProps {
  children: React.ReactNode;
}

/**
 * A page whose whole purpose is an LHPH staff action (run billing, fund, approve swaps).
 * The API refuses a dealer login on the action itself (lhphcapital-fdjb); this keeps a
 * dealer from landing on a page where the only button would answer 403.
 *
 * ⚠️ UX, not security — the control is `requireEveryCompany` on the route in the API.
 */
const StaffOnlyRoute: React.FC<StaffOnlyRouteProps> = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }
  if (!canRunStaffActions(user)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return <>{children}</>;
};

export default StaffOnlyRoute;
